var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 0H10.75C10.3125 0 10 0.34375 10 0.75V3.25C10 3.6875 10.3125 4 10.75 4H13.25C13.6562 4 14 3.6875 14 3.25V0.75C14 0.34375 13.6562 0 13.25 0ZM13 3H11V1H13V3ZM8.25 0H5.75C5.3125 0 5 0.34375 5 0.75V3.25C5 3.6875 5.3125 4 5.75 4H8.25C8.65625 4 9 3.6875 9 3.25V0.75C9 0.34375 8.65625 0 8.25 0ZM8 3H6V1H8V3ZM3.25 0H0.75C0.3125 0 0 0.34375 0 0.75V3.25C0 3.6875 0.3125 4 0.75 4H3.25C3.65625 4 4 3.6875 4 3.25V0.75C4 0.34375 3.65625 0 3.25 0ZM3 3H1V1H3V3ZM13.25 6H10.75C10.3125 6 10 6.34375 10 6.75V9.25C10 9.6875 10.3125 10 10.75 10H13.25C13.6562 10 14 9.6875 14 9.25V6.75C14 6.34375 13.6562 6 13.25 6ZM13 9H11V7H13V9ZM8.25 6H5.75C5.3125 6 5 6.34375 5 6.75V9.25C5 9.6875 5.3125 10 5.75 10H8.25C8.65625 10 9 9.6875 9 9.25V6.75C9 6.34375 8.65625 6 8.25 6ZM8 9H6V7H8V9ZM3.25 6H0.75C0.3125 6 0 6.34375 0 6.75V9.25C0 9.6875 0.3125 10 0.75 10H3.25C3.65625 10 4 9.6875 4 9.25V6.75C4 6.34375 3.65625 6 3.25 6ZM3 9H1V7H3V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.5e7e93e6.svg";
export { ForwardRef as ReactComponent };